<template>
  <div class="edit">
    <div class="edit_top">
      <router-link
        to="/reserve/edit"
        v-if="!isApply(reserve)"
        class="edit_router"
      >
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="detail_label">
            {{ nameLabel }}
          </div>
          <div class="detail_top_title">
            {{ reserve.name }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="detail_label">
            {{ reserveDateLabel }}
          </div>
          <div>
            {{ formatedDate(reserve.time) }}
          </div>
          <div class="detail_label">
            {{ statusLabel }}
          </div>
          <div>
            <span class="inline_line_feed">{{ statusText(reserve) }}</span>
          </div>
          <div class="detail_label">
            {{ uploadLabel }}
          </div>
          <div>
            {{ reserve.userName }}
          </div>
          <div class="detail_label">
            {{ fileNameLabel }}
          </div>
          <div>
            {{ reserve.fileName }}
          </div>
          <input
            v-if="!isApply(reserve)"
            type="button"
            :value="downloadLabel"
            class="setting_post_button"
            @click="showDownloadModal = true"
          />
          <input
            v-if="!isApply(reserve)"
            type="button"
            :value="verifyLabel"
            class="setting_post_button"
            @click="showVerifyModal = true"
          />
        </div>
      </div>
    </div>
    <div class="download_modal_window" v-if="showDownloadModal">
      <downloadModalWindow
        :question="downloadWord"
        @close="stayClose"
        @downloadFile="downloadFile"
      >
      </downloadModalWindow>
    </div>
    <div class="verify_modal_window" v-if="showVerifyModal">
      <verifyModalWindow @close="stayClose" @verifyFile="verifyFile">
      </verifyModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="stayClose">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="stayClose">
      </completeModalWindow>
    </div>
  </div>
</template>

<script>
import downloadModalWindow from '../modalWindow/downloadModalWindow.vue'
import verifyModalWindow from '../modalWindow/verifyModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      edit: '編集',
      nameLabel: '予約名',
      reserveDateLabel: '予約日時',
      statusLabel: '実行状況',
      uploadLabel: 'アップロード者名(ファイル更新者)',
      fileNameLabel: 'ファイル名',
      downloadLabel: 'ファイルのダウンロード',
      verifyLabel: 'ファイルの検証',
      router: '/reserve',
      downloadWord: 'ファイルのダウンロードを行いますか？',
      completeWord: '',
      failureWord: '',
      showDownloadModal: false,
      showVerifyModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    reserve() {
      return this.$store.state.reserve.reserve
    }
  },
  components: {
    downloadModalWindow,
    verifyModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    close(e) {
      this.showDownloadModal = false
      this.showVerifyModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showDownloadModal = false
      this.showVerifyModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    isApply(reserve) {
      return !(reserve.applyDate === null || reserve.applyDate === undefined)
    },
    formatedCheckedDate(unixTime) {
      return unixTime ? ` (${this.formatedDate(unixTime)})` : ''
    },
    formatedDate(unixTime) {
      const targetDate = new Date(unixTime)
      return `${targetDate.getFullYear()}/${(targetDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${targetDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${targetDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${targetDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    },
    statusText(reserve) {
      let statusText = reserve.statusText
      statusText += ' ' + this.formatedCheckedDate(reserve.statusDate)
      if (reserve.status === 3 && reserve.errorInfo !== undefined) {
        const infos = reserve.errorInfo.split(',')
        const errorCode = infos[0]
        const errorSheet = infos.length >= 3 ? infos[1] : ''
        const errorLine = infos.length >= 3 ? infos[2] : infos[1]
        statusText += '\n'
        if (this.errorMsg[errorCode] !== undefined) {
          statusText += this.errorMsg[errorCode].name
          if (this.errorMsg[errorCode].beforeValue) {
            statusText += this.errorMsg[errorCode].beforeValue
          }
        } else {
          statusText += errorCode
        }
        statusText += `${errorSheet !== '' ? errorSheet + 'シート\n' : ''}`
        statusText += `${
          errorLine !== '' && errorLine !== undefined ? errorLine + '' : ''
        }`
        if (this.errorMsg[errorCode] !== undefined) {
          if (this.errorMsg[errorCode].afterValue) {
            statusText += this.errorMsg[errorCode].afterValue
          } else if (this.errorMsg[errorCode].value) {
            statusText += this.errorMsg[errorCode].value
          }
        }
      }
      return statusText.replaceAll('<br/>', '\n')
    },
    async downloadFile() {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('reserve/setDownloadFile', this.reserve)
        const downloadType = this.$store.state.reserve.downloadContentType
        const downloadFile = this.$store.state.reserve.downloadData
        let link = document.createElement('a')
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([downloadFile], {type: downloadType})
          window.navigator.msSaveOrOpenBlob(
            blob,
            this.$store.state.reserve.reserve.fileName
          )
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([downloadFile], {type: downloadType})
          link.setAttribute(
            'download',
            this.$store.state.reserve.reserve.fileName
          )
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([downloadFile], {type: downloadType})
          link.setAttribute(
            'download',
            this.$store.state.reserve.reserve.fileName
          )
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.completeWord = 'ダウンロードしました。'
          this.showCompleteModal = true
        }
        if (downloadFile === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_700001
          let eventType = 9
          let reason = 'MSGCRC0217'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.failureWord =
            this.errorMsg.MSGCRC0217.name +
            this.errorMsg.MSGCRC0217.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFailureModal = true
          this.showloadingModal = false
          return
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0217 '
          this.failureWord =
            this.errorMsg.MSGCRC0217.name +
            this.errorMsg.MSGCRC0217.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    async verifyFile() {
      this.showVerifyModal = false
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('reserve/verifyReserve', this.reserve)
        await this.$store.dispatch('reserve/setDetailReserve', this.reserve)
        this.completeWord = 'ファイルの検証を開始しました。'
        this.showCompleteModal = true
        this.$emit('list-reload')
        if (location.pathname !== '/reserve/detail') {
          this.$router.push('../reserve/detail')
        }
        this.showloadingModal = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 9
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          this.failureWord =
            this.errorMsg.MSGCRC0221.name +
            this.errorMsg.MSGCRC0221.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason = 'MSGCRC0221 '
          reason += error.response.status
        } else {
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason = 'MSGCRC0005'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.inline_line_feed {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve/reserveDetail.vue